<template>
  <div class="container">
    <h3 class="title" v-if="this.title === 'galezieliscietrawa'">Gałęzie, liście, trawa</h3>
    <h3 class="title" v-if="this.title === 'obrazy'">Obrazy</h3>
    <h3 class="title" v-if="this.title === 'jedzenie'">Jedzenie</h3>
    <h3 class="title" v-if="this.title === 'Las'">Las</h3>
    <h3 class="title" v-if="this.title === 'egipt'">Egipt</h3>
    <h3 class="title" v-if="this.title === 'postacie'">Postacie</h3>
    <h3 class="title" v-if="this.title === 'zwierzeta'">Zwierzęta</h3>
    <h3 class="title" v-if="this.title === 'kamienie'">Kamienie</h3>
    <h3 class="title" v-if="this.title === 'kwiaty'">Kwiaty</h3>
    <h3 class="title" v-if="this.title === 'muszle'">Muszle</h3>
    <h3 class="title" v-if="this.title === 'fraktale'">Fraktale</h3>
    <h3 class="title" v-if="this.title === 'tla'">Tła</h3>
    <h3 class="title" v-if="this.title === 'szklaneimetaliczne'">Szklane i metaliczne</h3>
    <h3 class="title" v-if="this.title === 'krajobraz'">Krajobraz</h3>
    <h3 class="title" v-if="this.title === 'owoceiwarzywa'">Owoce i warzywa</h3>
    <h3 class="title" v-if="this.title === 'drewno'">Drewno</h3>
    <h3 class="title" v-if="this.title === 'sport'">Sport</h3>
    <h3 class="title" v-if="this.title === 'niebo'">Niebo</h3>
    <h3 class="title" v-if="this.title === 'motoryzacja'">Motoryzacja</h3>
    <h3 class="title" v-if="this.title === 'dzieciece'">Dziecięce</h3>
    <h3 class="title" v-if="this.title === 'woda'">Woda</h3>
    <h3 class="title" v-if="this.title === 'architektura'">Architektura</h3>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    }
  }
}
</script>
